import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class EbDashboardEmailService {
  routePrefix = '/api/eb-email-generation';
  requestTokenKey = 'requestToken';
  requestToken: string;
  constructor(private http: HttpClient) { }

  getRequestTokenHeader(): HttpHeaders {
    this.requestToken = sessionStorage.getItem(this.requestTokenKey);
    return new HttpHeaders().set(this.requestTokenKey, this.requestToken);
  }

  sendMembersAndBenefitsEmail(enrolId:number): Observable<any>{
    return this.http.get<any>(this.routePrefix + '/send-members-benefits-email/' + enrolId, { headers: this.getRequestTokenHeader() });
  }

  generateEbMedicalCardPdf = (enrolId: number) => {
    return this.http.get(`${ this.routePrefix }/send-medical-card-email/${ enrolId }`,
     { responseType: 'blob', headers: this.getRequestTokenHeader() }).pipe(map((result: any) => {
      return result;
    }));
  }

  sendEbDashboardMedicalCardEmail = (data: any) => {
    return this.http.post(this.routePrefix + '/send-medical-card-email', data, { headers: this.getRequestTokenHeader() });
  }

  sendEbDashboardLifeCardEmail(enrolId:number): Observable<any>{
    return this.http.get(this.routePrefix + '/send-life-card-email/' + enrolId, { headers: this.getRequestTokenHeader() });
  }
  
  sendPaymentExplanationEmail(data): Observable<any>{
    return this.http.post(this.routePrefix + '/send-payment-explanation-email', data, { headers: this.getRequestTokenHeader() });
  }

  sendClaimUsageEmail(data): Observable<any>{
    return this.http.post(this.routePrefix + '/send-claim-usage-email', data, { headers: this.getRequestTokenHeader() });
  }
}
